import { useGame } from "./GameContext";
import HintList from "./HintList";
import HintDetail from "./HintDetail";

export default function HintContainer() {
  const { hintView } = useGame();

  if (hintView === "NONE") return null;

  return (
    <div className="hint_overlay storage_box ans0002 box_storage_bg ">
      {hintView === "LIST" && <HintList />}
      {hintView === "DETAIL" && <HintDetail />}
    </div>
  );
}
